import { decode } from "@utils/commUtils";
export const defWidth = 1920;
//LIST COUNT
export const NUM_WLISTCNT = 10;
export const NUM_MLISTCNT = 3;
//AUTO 로그인
export const NUM_DIFFTIME_SEC_DEV = 600;
export const NUM_DIFFTIME_SEC_PROD = 600;
export const NUM_DIFFTIME_SEC = process.env.NODE_ENV.includes("dev") ? NUM_DIFFTIME_SEC_DEV : NUM_DIFFTIME_SEC_PROD;
//LANGUAGES
export const STR_LANG_KOR = "ko_KR";
export const STR_LANG_ENG = "en_US";
export const STR_LANG_I18N = "langs";
export const STR_APILANG_KOR = "Korean";
export const STR_APILANG_ENG = "English";
//ROLE
export const USERROLE_ADMIN = "ROLE_ADMIN";
export const USERROLE_ENGINEER = "ROLE_ENGINEER";
export const USERROLE_SUPER = "ROLE_SUPERUSER";
export const USERROLE_USER = "ROLE_USER";
export const USERROLE_NONE = "ROLE_NONE";
//로그인 STRING KEY
export const STR_USERID = "userId";
export const STR_USERROLE = "role";
export const STR_TOKEN = "token";
export const STR_TOKEN_EXPIRETIME = "tokenExpireTime";
export const STR_REFRESHTOKEN = "refreshToken";
export const STR_REFRESHTOKEN_EXPIRETIME = "refreshTokenExpireTime";
export const STR_KEEP_LOGIN_YN = "keepLoginYn";
export const STR_EHP_MENULIST = "ehpMenuList";
export const STR_EHP_DASHBODRD_CARDORDER = "ehpDashboardCardorder";
export const STR_EHP_DASHBODRD_PIN = "ehpDashboardPin";
// URL PARAM
export const STR_PARAM_DATA = "EHP_EX_DATA";
export const STR_PARAM_PDFID = "EHP_PDF_ID";
export const STR_PARAM_PDFNM = "EHP_PDF_NM";
export const STR_EMAIL = "email";
export const STR_KEY = "key";
//메뉴
export const URL_SEI = "/";
export const URL_MAIN = "/main";
export const URL_WHATWEDO = "/whatewdo";
export const URL_MARKETPLACE = "/marketplace";
export const URL_CONTACTUS = "/contactus";
export const URL_COMMUNITY = "/community";
export const URL_DOWNLOAD = "/download";
export const URL_MYPAGE = "/mypage";
//대쉬보드 로그인
export const URL_LOGIN = "/login";
//대쉬보드 메인
export const URL_MONITORING = "/monitoring";
export const URL_TODAYINSPECTION = "/todayinspection";
export const URL_ENERGYSOLUTION = "/energySolution";
export const URL_CONSULTION = "/consulting";
export const URL_OPERATION = "/operation";
export const URL_REPORT = "/report";
export const URL_PROPOSAL = "/proposal";
//Management
export const URL_APPROVALMANAGEMENT = "/approvalmanagement";
export const URL_USERMANAGEMENT = "/usermanagement";
export const URL_SITEMANAGEMENT = "/sitemanagement";
export const URL_MESSAGEMANAGEMENT = "/messagemanagement";
export const URL_MENUMANAGEMENT = "/menumanagement";
export const URL_CHECKSHEETMANAGEMENT = "/checksheetmanagement";
export const URL_ECONSULTMANAGEMENT = decode("/\\u0065\\u0063\\u006f\\u006e\\u0073\\u0075\\u006c\\u0074\\u006d\\u0061\\u006e\\u0061\\u0067\\u0065\\u006d\\u0065\\u006e\\u0074");
export const URL_SPGMANAGEMENT = decode("/\\u0073\\u0070\\u0067\\u006d\\u0061\\u006e\\u0061\\u0067\\u0065\\u006d\\u0065\\u006e\\u0074");
export const URL_SOLUTIONMANAMENT = decode("/\\u0073\\u006f\\u006c\\u0075\\u0074\\u0069\\u006f\\u006e\\u006d\\u0061\\u006e\\u0061\\u0067\\u0065\\u006d\\u0065\\u006e\\u0074");
export const URL_COMMUNITYMANAGEMENT = decode("/\\u0063\\u006f\\u006d\\u006d\\u0075\\u006e\\u0069\\u0074\\u0079\\u006d\\u0061\\u006e\\u0061\\u0067\\u0065\\u006d\\u0065\\u006e\\u0074");
export const URL_INFOMANAGEMENT = decode("/\\u0069\\u006e\\u0066\\u006f\\u006d\\u0061\\u006e\\u0061\\u0067\\u0065\\u006d\\u0065\\u006e\\u0074");
export const URL_DOWNLOADMANAGEMENT = decode("/\\u0064\\u006f\\u0077\\u006e\\u006c\\u006f\\u0061\\u0064\\u006d\\u0061\\u006e\\u0061\\u0067\\u0065\\u006d\\u0065\\u006e\\u0074");
export const URL_ENERGYSOLUTIONMANAGEMENT = decode("/\\u0065\\u006e\\u0065\\u0072\\u0067\\u0079\\u0053\\u006f\\u006c\\u0075\\u0074\\u0069\\u006f\\u006e\\u004d\\u0061\\u006e\\u0061\\u0067\\u0065\\u006d\\u0065\\u006e\\u0074");
//서비스 요청
export const URL_INTRODUCTIONINQUIRY = "/introductioninquiry";
export const URL_HELP = "/help";
export const URL_COMM_PDFVIEWER = "/pdfviewer";
export const URL_VERIFYEMAIL = "/verifyEmail";
export const URL_VERIFYEMAILCOMMUNITY = "/verifyEmailCommunity";
export const URL_NOT_FOUND = "/notfound";
export const URL_SYSTEM_ERROR = "/systemerror";
export const startUrl = "startUrl";
//API RESULT
export const API_200 = 200; // HTTP 200
export const API_999 = 999; // unknown system error
export const APISTATUS_500 = 500; // unknown system error
export const MSG_SUCCESS = "success"; // api msg
export const MSG_FAIL = "fail"; // api msg
//APP FIELD DATA
export const FLD_AUTOFIELD = "autofield";
export const FLD_MSG_DELETE_COMMON = "요청하신 정보가 삭제되었습니다.";
// pop 관련
export const POP_CONFIRM = "pop-confirm";
export const POP_CMM_CONFIRM = "pop-cmmConfirm";
export const POP_ALERT = "pop-alert";
export const POP_RELOAD = "pop-reload";
export const POP_LANDING = "pop1";
export const POP_LOGIN = "pop-login";
export const POP_AUTO = "pop-auto-nickname";
// pop type
export const TYPE_NONE = "none";
export const TYPE_INNRE = "inner";
export const TYPE_ERROR = "error";
export const TYPE_LANDING = "landing";
export const BACNINH = "1234567890";
export const TRIAL = "9999999999";
export const FITNESS = "적합";
export const barColor = [
    { color: "#0F5FA5", name: "navy" },
    { color: "#084A84", name: "dark-cerulean" },
    { color: "#00DACD", name: "mint" },
    { color: "#13A79E", name: "deep-cyan" },
    { color: "#FF6781", name: "red" },
    { color: "#FF387D", name: "deep-pink" },
    { color: "#7D5CBE", name: "lavender" },
    { color: "#663C90", name: "dark-purple" },
    { color: "#E76700", name: "dark-orange" },
    { color: "#FF9900", name: "orange" },
];
export const ERROR_MSG = "요청하신 작업을 처리하는 데 문제가 발생했습니다.";
export const ERROR_SERVER_MSG = "현재 시스템 점검 중이거나 예상치 못한 오류가 발생했습니다.";
//proposal type
export const PROPOSAL_ANALYSIS = "ANALYSIS_REPORT";
export const PROPOSAL_FIRST = "FIRST_PROPOSAL";
